module.exports = __webpack_public_path__ + "static/ClareBakerSmith-6ae213918aff0e8dac55c95b7dc5a2e0.jpg";